import { useQuery, gql } from "@apollo/client";

import { SKILL_FRAGMENT } from "./useGetSkills";

export const TEMPLATE_FRAGMENT = gql`
  fragment TemplateFragment on Template {
    id
    slug
    createdAt
    updatedAt
    default
    color
    title
    taskTrackingEnabled
    color
    contractTemplateIds
    canInsert
    canShow
    contractTemplates {
      id
      title
    }
    templateSections {
      title
      description
      order
      type
      templateQuestions {
        id
        description
        label
        referents {
          id
          name
          slug
        }
        order
        reportTypes
        defaultValue
        options
        optionsSchema
        type
        referentIds
        subjectId
        subjectType
        timeTracked
        subject {
          ... on Skill {
            ...SkillFragment
          }
        }
      }
    }
  }
  ${SKILL_FRAGMENT}
`;

export const GET_TEMPLATE = gql`
  query getTemplate($id: ID!) {
    template(id: $id) {
      ...TemplateFragment
    }
  }
  ${TEMPLATE_FRAGMENT}
`;

export default (options) => {
  return useQuery(GET_TEMPLATE, options);
};
